import { createLifecycleFor } from 'ext/lib/collections';

export const TYPE = 'userProperties' as const;

export const { resolve, reject, patterns } = createLifecycleFor(TYPE);

/**
 * Register a profile attribute authored in a builder. The lifecycle actions
 * describe fetching the account's attributes; this one asks the account to
 * learn about a new one, so it gets its own type — deliberately not the
 * lifecycle's `create`, whose `patterns.create` matcher this would not satisfy.
 */
export const REGISTER = `${TYPE}/REGISTER` as const;

export const registerUserProperty = (value: string, name: string) => ({
  type: REGISTER,
  payload: { value, name },
  meta: { type: TYPE },
});

/**
 * Registration is a side write that must not be reported as a failed save.
 * `reject` would do exactly that: the global status reducer maps
 * `REQUEST_REJECTED` to 'error' without checking `meta.type`, which the
 * builder renders as "Couldn't save changes".
 */
export const REGISTER_FAILED = `${TYPE}/REGISTER_FAILED` as const;

export const registerUserPropertyFailed = (error: unknown) => ({
  type: REGISTER_FAILED,
  payload: error,
  meta: { type: TYPE },
});
